import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import {getSoPending} from '../../Service/SalesService';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay';
import moment from 'moment';

const ApprovalSO = () => {
    const navigate = useNavigate();
    const tableSO = useRef();
    const [state, setState] = useState({ processing : false });

    const onEdit = item => () => {
        navigate("/salesorderapproval/view/" + item.id);
    };

    const columns = [
        { id: 1, title: 'Order Number', field: 'DocNumSO', sortable: true },
        { id: 2, title: 'Customer', field: 'CardName', sortable: true },
        { id: 3, title: 'Created Date', field: 'DocDate', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23. You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03 and 2023-04-01 16.04",  
        render: data => {
            // moment.locale('id');
            return moment(data.created_date).locale('id').format('ll LTS')
        }
        },
        { id: 5, title: 'MHC', field: 'bplfrname', sortable: true },
        {
            id: 4,
            title: 'Status',
            field: 'Status',
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.Status == 'Reject') {
                    text = <span className="badge bg-red me-2">Reject</span>;
                } else if (data.Status == 'Paid') {
                    text = <span className="badge bg-paid me-2">Paid</span>;
                } else if (data.Status == 'Closed') {
                    text = <span className="badge bg-close me-2">Closed</span>;
                } else if (data.Status == 'Open') {
                    text = <span className="badge bg-cyan me-2">Open</span>;
                } else if (data.Status == 'Pending') {
                    text = <span className="badge bg-teal me-2">Pending</span>;
                }
                return text;
            },
        },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div style={{ width: 100 }}>
                        <a
                            onClick={onEdit(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-eye" />
                            <span style={{ marginLeft: 10 }}>View</span>
                        </a>
                        
                    </div>
                );
            },
        },
    ];

    // const listpph = () => getSO({filter: `Status:Pending`,search:'',order: 'created_date', direction: 'desc'});
    const propsTable = { columns, getData: getSoPending , order: 'created_date', direction: 'desc' , showIndex: true};

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Sales Order Approval List</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <Overlay display={state.processing} />
                            <div className='table-responsive'>
                                <MTable {...propsTable} ref={tableSO} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default ApprovalSO;